import React, { Component } from 'react';
import throttle from "lodash.throttle";
import DemandPlannerVersionMiddleware from '../../../store/middleware/demandPlannerVersionMiddleware';
import { connect } from "react-redux";
import DownloadIcon from '../../../assets/images/downloadIcon.svg'


class HumanGeneratedVersion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isMachineGenerated:true,
            value: '',
            selectedForecast:false,
            versionPage:1,
            versions:[]
        }
    }
    propsReceived=(value)=>{
        value.forEach(item=>(this.state.versions.push(item)))
      }
      componentWillReceiveProps(nextProps){
        if(nextProps.demandPlannerVersion && !nextProps.isDemandPlannerVersionLoading && !nextProps.demandPlannerVersionHasError){
          this.propsReceived(nextProps.demandPlannerVersion.results);
        }
    }
    componentDidMount(){
        this.props.getDemandPlannerVersions(
            this.state.versionPage,
            this.state.selectedForecast
        )

        this.page_wrapper_version.onscroll = e => {
            if(this.props.isDemandPlannerVersionLoading)return
            const obj = e.target;
            const height = obj.scrollHeight - obj.offsetHeight;
            const scrollPos = obj.scrollTop;
            const factor = 0.9;
            if (scrollPos >= factor * height) {
              this.load_more_versions();
            }
          };
    }
    load_Versions() {
        if(this.props.isDemandPlannerLoading || this.props.demandPlannerVersionHasError)return;
        this.setState({
            versionPage:this.state.versionPage+1
        },
        ()=>{
        this.props.getDemandPlannerVersions(
            this.state.versionPage,
            this.state.selectedForecast
        );
        }
        )
      }
    
      load_more_versions = throttle(this.load_Versions, 800, {
        trailing: false
      });
      handleDownload=index=>{
        const file=this.state.versions[index]
        setTimeout(()=>{
          const url = 'https://staging-unilever.nexdegree.com/'+file.Upload
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.VersionName); //or any other extension
                document.body.appendChild(link);
                link.click();
        },500)

      }
  render() {
    return (
        <div className='tab-data'
        ref={c => (this.page_wrapper_version = c)}
        >
          {this.state.versions.length?this.state.versions.map((item,index)=>(
          <div className='version-title' key={index} onClick={()=>this.handleDownload(index)}>
          <p className='version-name'>{item.VersionName}</p>
          <img alt='' className='version-image' src={DownloadIcon}/>
          </div>
          )):[]}</div>
    );
  }
}
const mapStateToProps = state => {
    return {
        isDemandPlannerVersionLoading:state.DemandPlannerVersionReducer.isDemandPlannerVersionLoading,
        demandPlannerVersion:state.DemandPlannerVersionReducer.demandPlannerVersion,
        demandPlannerVersionHasError:state.DemandPlannerVersionReducer.demandPlannerVersionHasError
    };
  };
  
  const mapDispatchToprops = dispatch => {
    return {
        getDemandPlannerVersions: (page,selectedForecast) => {
        return dispatch(DemandPlannerVersionMiddleware.getDemandPlannerVersions(page,selectedForecast));
      }
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToprops)(HumanGeneratedVersion);
